export enum Constant {
  CODE_EXC = 'FLAG_EXCLUDE',
  CODE_EMPTY = 'FLAG_EMPTY',
  CODE_ALL = 'FLAG_ALL',
  CODE_ALL_LABEL = '全选',

  FEAT_AUTO_PPLT = 'AUTO_PPLT',
  FEAT_SMS_AUTH_EXPIRE_TIME = 'SMS_VERIFY_RES_LOST_TIME',
  FEAT_EMAIL_AUTH_EXPIRE_TIME = 'EMAIL_VERIFY_RES_LOST_TIME',

  FEAT_ENABLE_OMNI_MBD = 'FEAT_ENABLE_OMNI_MBD',

  FEAT_TREND_DOWNLOAD_SPLIT_THRESHOLD = 'TREND_DOWNLOAD_SPLIT_THRESHOLD',
  FEAT_TREND_VIEW_SPLIT_THRESHOLD = 'TREND_VIEW_SPLIT_THRESHOLD',
  PROVINCE_VIEW_SPLIT_THRESHOLD = 'PROVINCE_VIEW_SPLIT_THRESHOLD',

  FEAT_PROD_KWS_THRESHOLD = 'FILTER_PROD_KWS_THRESHOLD',
  FEAT_PROD_IDS_THRESHOLD = 'FILTER_PROD_IDS_THRESHOLD',

  FEAT_MAX_IMPORT_PERIODS = 'MAX_IMPORT_PERIODS',
  FEAT_ECOM_ENV = 'ECOMM_ENV',

  ROLE_FREE_TRIAL = 'FREE_TRIAL',
  ROLE_INTERNAL = 'INTERNAL',
  CLIENT_POWER = 'CLIENT_POWER',
  SUPER_ADMIN = 'SUPER_ADMIN',

  BELONG_TO_SELF = 'SELF',

  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  RUNNING = 'IN PROGRESS',
  INQUEUE = 'IN QUEUE',


  FORMAT_MONTH = 'yyyy-MM',
  FORMAT_DATE = 'yyyy-MM-dd',
  FORMAT_HOURS = 'yyyy-MM-dd HH:mm:ss',

  YES = 'Y',

  ALL = 'ALL',
}
